/**
 * @generated SignedSource<<29f13d9e8641f2a35604e65aa3391f8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UsersMapDetails_usersMap",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapFilters_map"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapUsersList_usersMap"
    }
  ],
  "type": "UsersMap",
  "abstractKey": null
};

node.hash = "30c6d65ac129a0d4d97192a246803111";

module.exports = node;
